
































import Vue from 'vue'
import { isUserSelectingText } from '@/core/selection'
import SourceSelectDialog from '@/components/source-select.vue'
export default Vue.extend({
  components: {
    SourceSelectDialog,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    onSourcesClick() {
      if (!isUserSelectingText()) {
        this.dialog = true
      }
    },
    onSourcesDoubleClick() {
      this.dialog = true
    },
    onSourceSelect(event: any) {
      this.$emit('input', event)
      this.dialog = false
    },
  },
})
